import { FetcherAmplify } from 'src/business/Libraries/Fetcher/FetcherAmplify';
import { InstitucionalAffidavitI } from '../domain/InsitucionalAffidavit';
import { AffidavitBusinessFinalBeneficiary } from '../domain/AffidavitFinalBeneficiaryBusiness';
import ComplianceRepositoryI from './ComplianceRepositoryI';
import { CustomerType } from 'blum-rivendell-frontend/dist/customer/domain/Customer';

export default class ComplianceRepositoryImpl implements ComplianceRepositoryI {
  private fetcher: FetcherAmplify;

  constructor(fetcher: FetcherAmplify) {
    this.fetcher = fetcher;
  }

  getPendingAffidavitsWithUrlByCustomerId(
    customerId: string,
  ): Promise<InstitucionalAffidavitI[]> {
    return this.fetcher.get(`/v1/customers/${customerId}/affidavits`, {
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
        onlyLast: false,
        status: 'PENDING_SIGNATURE',
        includeUrl: true,
      },
    });
  }

  async createBusinessAffidavit(
    customerId: string,
    data: AffidavitBusinessFinalBeneficiary,
  ): Promise<void> {
    await this.fetcher.post(`/v1/affidavits`, {
      body: data,
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
        affidavitType: 'FINAL_BENEFICIARY',
      },
    });
  }

  async generatePreviewBusinessAffidavit(
    customerId: string,
    data: AffidavitBusinessFinalBeneficiary,
  ): Promise<any> {
    return this.fetcher.post(`/v1/affidavits-preview`, {
      body: data,
      queryStringParameters: {
        customerId,
        customerType: CustomerType.BUSINESS,
      },
    });
  }
}
